import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55ce58df"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "height": "90px",
    "background-color": "white",
    "box-shadow": "5px 0px 9px 0px #e5e9f2"
  }
};
const _hoisted_4 = {
  class: "shop-info-box"
};
const _hoisted_5 = {
  class: "shop-info-item"
};
const _hoisted_6 = {
  class: "shop-info-item"
};
const _hoisted_7 = {
  class: "shop-info-item"
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "flex": "1",
    "background-color": "white",
    "margin-top": "20px",
    "position": "relative"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一键审核", -1));
const _hoisted_10 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "道具/画面点位图", -1));
const _hoisted_12 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
};
const _hoisted_13 = {
  style: {
    "display": "flex",
    "flex": "1",
    "color": "#777777"
  }
};
const _hoisted_14 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin-left": "20px",
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_15 = {
  key: 1,
  style: {
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px",
    "margin": "10px 0px"
  }
}, " 道具信息： ", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_19 = {
  key: 0,
  style: {
    "display": "flex",
    "font-size": "14px"
  }
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  style: {
    "display": "flex",
    "font-size": "12px"
  }
};
const _hoisted_22 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "5px",
    "width": "160px"
  }
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "5px"
  }
};
const _hoisted_24 = {
  style: {
    "width": "205px",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_25 = {
  key: 0,
  style: {
    "position": "absolute",
    "inset": "0",
    "display": "flex",
    "padding": "5px",
    "flex-shrink": "0",
    "flex-wrap": "wrap",
    "align-content": "flex-start",
    "align-items": "flex-start",
    "justify-content": "flex-start",
    "gap": "10px",
    "margin-left": "5px",
    "font-size": "12px"
  }
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin-left": "10px"
  }
};
const _hoisted_28 = {
  style: {
    "flex": "1",
    "position": "relative",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border": "1px solid black",
    "margin-right": "10px"
  }
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  style: {
    "width": "24px",
    "height": "24px",
    "background-color": "#00a5fa",
    "border-radius": "50%",
    "bottom": "90px",
    "right": "30px",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "cursor": "pointer"
  }
};
const _hoisted_31 = {
  style: {
    "display": "flex",
    "margin-top": "10px"
  }
};
const _hoisted_32 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_33 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_44 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_45 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "120px"
  }
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修", -1));
const _hoisted_47 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden",
    "font-size": "14px",
    "color": "#777777",
    "padding": "0px 20px"
  }
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "border-bottom": "1px solid #d7d4d4",
    "height": "30px",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "60px"
  }
}, "楼层"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center",
    "min-width": "180px",
    "flex": "1"
  }
}, " 点位 "), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "300px",
    "flex": "3"
  }
}, "道具信息"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center",
    "flex": "2"
  }
}, "活动名称"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "margin-left": "5px",
    "max-width": "468px",
    "min-width": "468px"
  }
}, " 图片 ")], -1));
const _hoisted_49 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_50 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "position": "absolute",
    "inset": "0px"
  }
};
const _hoisted_51 = {
  style: {
    "min-width": "60px"
  }
};
const _hoisted_52 = {
  style: {
    "min-width": "160px",
    "display": "flex",
    "flex-direction": "column",
    "background-color": "#676a6d",
    "border-radius": "4px",
    "color": "white",
    "align-items": "center",
    "margin": "0px 10px",
    "padding": "10px 0px",
    "flex": "1"
  }
};
const _hoisted_53 = {
  style: {
    "display": "flex",
    "min-width": "300px",
    "flex": "3"
  }
};
const _hoisted_54 = {
  style: {
    "min-width": "150px",
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
};
const _hoisted_55 = {
  style: {
    "min-width": "150px",
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
};
const _hoisted_56 = {
  style: {
    "flex": "2",
    "text-align": "center"
  }
};
const _hoisted_57 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "start",
    "max-width": "468px",
    "min-width": "468px",
    "height": "155px"
  }
};
const _hoisted_58 = {
  key: 0,
  class: "tabBox"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  style: {
    "display": "flex",
    "align-items": "start"
  }
};
const _hoisted_61 = {
  style: {
    "display": "flex",
    "margin-top": "5px"
  }
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "审核通过", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "拒绝", -1));
const _hoisted_64 = {
  key: 0,
  style: {
    "display": "flex",
    "align-self": "stretch",
    "align-items": "center"
  }
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加图片", -1));
const _hoisted_66 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "屏幕点位图", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
}, null, -1));
const _hoisted_69 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_70 = {
  style: {
    "padding": "0px 5px",
    "background-color": "#676a6d",
    "color": "white",
    "border-radius": "4px"
  }
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_72 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%",
    "height": "433px",
    "position": "relative",
    "border": "1px solid black"
  }
};
const _hoisted_73 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X：", -1));
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y：", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_77 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "100px"
  }
}, "报修信息", -1));
const _hoisted_79 = {
  style: {
    "position": "absolute",
    "text-align": "center",
    "right": "30px"
  }
};
const _hoisted_80 = ["src"];
const _hoisted_81 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "20px"
  }
}, "请用微信扫码报修", -1));
const _hoisted_83 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_84 = ["src"];
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, null, -1));
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "QRtitle"
}, null, -1));
const _hoisted_87 = {
  class: "copyQR"
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode, computed, onBeforeUnmount, watch } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import MapWithMarkers from "../components/MapWithMarkers.vue";
import showConfirmModal from "@/util//showConfirmModal";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import { Plus } from "@element-plus/icons-vue";

import { ElNotification, ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'StoreLocation',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const code = route.params.storeCode;
    const installationId = route.query.installationId;
    const activityId = route.query.activityId;
    const dataTabsKey = ref("1");
    const imageryTabModel = ref(1);
    const QRcodeVisible = ref(false);
    const QRcodeBox = ref(null);
    const QRcodeMsg = reactive({});
    const wxCodeImage = ref(null);
    const pointLocationSummaryIndex = ref(null);
    const repairOpenVisible = ref(false);
    const repairEditFormData = ref({
      repairUrgent: 1
    });
    const repairEditForm = ref(null);
    let imageryTabModelJson = JSON.parse(window.localStorage.getItem("imagery_tab_model") || '{"value":1}');
    const storeLocationTreeProps = {
      value: "storeLocationId",
      label: "locationName",
      children: "locations"
    };
    imageryTabModel.value = imageryTabModelJson.value;
    const storeLocationData = reactive({
      treeData: {},
      listData: [],
      floorData: [],
      treeOptionData: [],
      locationsByStoreLocationId: {},
      props: {
        label: "locationName",
        children: "locations"
      }
    });
    const controlData = reactive({
      tab: {
        tabIndex: new Array(5),
        tabData: new Array(5)
      },
      locationInfo: null,
      currentUploadedInfo: null,
      currentFloor: null,
      locationLabel: null
    });
    const initialPoints = computed(() => {
      if (controlData.currentFloor != null) {
        return controlData.currentFloor.storeFloorPoints.map(floor => ({
          id: floor.storeFloorPointId,
          x: floor.pointX,
          y: floor.pointY
        }));
      }
      return [];
    });
    onMounted(async () => {
      const storeLocationRO = {
        storeCode: code,
        installationId: installationId,
        activityId: activityId
      };
      await getStoreLocation(storeLocationRO);
      await getStoreFloor(code);
      changeTab(0, 0);
    });
    const addDisableProperty = data => {
      // 深拷贝数据，避免修改原始数据
      const copyData = JSON.parse(JSON.stringify(data));
      const updateData = (arr, parentPath) => {
        if (!parentPath) {
          parentPath = "";
        }
        return arr.map(item => {
          // 给当前对象添加 disable: true
          if (!item.storeLocationId) {
            item.disabled = true;
            item.storeLocationId = uuidv4();
            item.fullPath = "";
          } else {
            item.fullPath = parentPath.substring(1) + "/" + item.locationName;
          }

          // 如果有 children，递归调用
          if (item.locations && item.locations.length > 0) {
            item.locations = updateData(item.locations, parentPath + "/" + item.locationName);
          }
          return item;
        });
      };
      return updateData(copyData);
    };
    const changeTab = (activeTabIndex, level) => {
      controlData.tab.tabIndex[level] = activeTabIndex;
      for (let i = level + 1; i < 5; i++) {
        controlData.tab.tabIndex[i] = 0;
      }
      onChangeTabData(storeLocationData.treeData.storeFloors, 0);
    };
    const onChangeTabData = (data, level) => {
      console.log(data, level);
      if (level == 5) {
        controlData.locationInfo = controlData.tab.tabData[4][controlData.tab.tabIndex[4]];
        if (Array.isArray(controlData.locationInfo.uploadedInfo)) {
          controlData.currentUploadedInfo = controlData.locationInfo.uploadedInfo[0];
        }
        if (controlData.currentFloor && Array.isArray(controlData.currentFloor.storeFloorPoints)) {
          let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
          pointLocationSummaryIndex.value = null;
          let findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location && item.locationSummary === null);
          if (findIndex !== -1) {
            pointLocationSummaryIndex.value = 3;
            selectPoint(controlData.currentFloor.storeFloorPoints[findIndex].storeFloorPointId);
          } else {
            findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location && item.locationSummary === findLocation.locationSummary);
            if (findIndex != -1) {
              pointLocationSummaryIndex.value = 4;
              selectPoint(controlData.currentFloor.storeFloorPoints[findIndex].storeFloorPointId);
            } else {
              selectId.value = null;
            }
          }
        }
        console.log(controlData.locationInfo);
        return;
      }
      controlData.tab.tabData[level] = data;
      if (level === 0) {
        let floorList = storeLocationData.floorData.filter(item => item.storeFloor === data[controlData.tab.tabIndex[level]].locationName);
        if (Array.isArray(floorList) && floorList.length > 0) {
          if (controlData.currentFloor !== floorList[0]) {
            controlData.currentFloor = floorList[0];
          }
        }
      }
      onChangeTabData(data[controlData.tab.tabIndex[level]].locations, level + 1);
    };
    const onChangeTabByStoreLocation = storeLocation => {};
    const onPreviewChange = item => {
      controlData.currentUploadedInfo = item;
    };

    //获取店铺位置
    const getStoreLocation = async code => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocation(code, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202104") {
              //没有点位信息返回
              if (res.result.data.storeFloors.length === 0) {
                ElNotification({
                  title: "失败",
                  message: "暂无点位信息",
                  type: "error",
                  duration: 3000
                });
                router.go(-1);
              } else {
                storeLocationData.treeData = res.result.data;
                repairEditFormData.value.storeName = storeLocationData.treeData.storeName;
                repairEditFormData.value.storeCode = storeLocationData.treeData.storeCode;
                if (Array.isArray(res.result.data.storeFloors)) {
                  storeLocationData.treeOptionData = addDisableProperty(res.result.data.storeFloors);
                  storeLocationData.treeOptionData.push({
                    locationName: "其它",
                    storeLocationId: 0
                  });
                }
                //排序
                let customOrder = ["Primary Story", "RN", "BB", "Liftstyle", "Training", "Bra & Leggings", "YA", "JORDAN", "NBY", "JBY", "365"];
                for (let i = 0; i < storeLocationData.treeData.storeFloors.length; i++) {
                  let arr = storeLocationData.treeData.storeFloors[i].locations;
                  arr.sort((a, b) => {
                    const indexA = customOrder.indexOf(a.locationName);
                    const indexB = customOrder.indexOf(b.locationName);
                    return indexA - indexB; // 升序排序，如果需要降序，则改为 `return indexB - indexA;`
                  });
                }

                storeLocationData.listData.length = 0;
                if (Array.isArray(storeLocationData.treeData.storeFloors)) {
                  for (let storeFloor of storeLocationData.treeData.storeFloors) {
                    if (Array.isArray(storeFloor.locations)) {
                      for (let location1 of storeFloor.locations) {
                        if (Array.isArray(location1.locations)) {
                          for (let location2 of location1.locations) {
                            if (Array.isArray(location2.locations)) {
                              for (let location3 of location2.locations) {
                                if (Array.isArray(location3.locations)) {
                                  for (let location4 of location3.locations) {
                                    const locationLabel = storeFloor.locationName + "-" + location1.locationName + "-" + location2.locationName + "-" + location3.locationName + "-" + location4.locationName;
                                    const locationObject = {
                                      locationLabel: locationLabel,
                                      activityName: location4.activityName,
                                      activityId: location4.activityId,
                                      floor: storeFloor.locationName,
                                      category: location1.locationName,
                                      region: location2.locationName,
                                      location: location3.locationName,
                                      locationSummary: location4.locationName,
                                      supportType: location4.supportType,
                                      ice: location4.ice,
                                      gender: location4.gender,
                                      locationDescription: location4.locationDescription,
                                      quantity: location4.quantity,
                                      materialAndCraft: location4.materialAndCraft,
                                      sizeDescription: location4.sizeDescription,
                                      width: location4.width,
                                      height: location4.height,
                                      storeLocationId: location4.storeLocationId,
                                      installationStatusId: location4.installationStatusId,
                                      originalUploaded: [],
                                      uploaded: [],
                                      activityVendors: location4.activityVendors,
                                      vendorTabIndex: 0
                                    };
                                    storeLocationData.listData.push(locationObject);
                                    if (Array.isArray(location4.uploadedInfo)) {
                                      for (let info of location4.uploadedInfo) {
                                        locationObject.uploaded.push(info);
                                      }
                                    }
                                    if (activityId) {
                                      for (let vendor of locationObject.activityVendors) {
                                        const filteredVendorArray = locationObject.uploaded.filter(function (element) {
                                          return element.vendorId === vendor.vendorId;
                                        });
                                        if (filteredVendorArray.length == 0) {
                                          vendor.isEmpty = true;
                                        } else {
                                          for (let upload of filteredVendorArray) {
                                            upload.vendorName = vendor.vendorName;
                                          }
                                        }
                                      }
                                      locationObject.originalUploaded = locationObject.uploaded;
                                      vendorTabBarChange(locationObject, 0);
                                    }
                                    storeLocationData.locationsByStoreLocationId[location4.storeLocationId] = locationObject;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                resolve(res.result.data);
              }
            } else {
              ElNotification({
                title: "失败",
                message: res.result.promptMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取店铺楼层
    const getStoreFloor = async storeCode => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreFloor(storeCode, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202120") {
              let floorData = res.result.data;
              storeLocationData.floorData.length = 1;
              if (Array.isArray(floorData)) {
                for (let floor of floorData) {
                  let floorPoints = [];
                  if (Array.isArray(floor.storeFloorPoints)) {
                    for (let point of floor.storeFloorPoints) {
                      let findIndex = storeLocationData.listData.findIndex(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location);
                      if (findIndex != -1) {
                        floorPoints.push(point);
                      }
                    }
                  }
                  floor.storeFloorPoints = floorPoints;
                  storeLocationData.floorData.push(floor);
                }
              }
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "失败",
                message: res.result.promptMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const vendorTabBarChange = (locationObject, index) => {
      let vendor = locationObject.activityVendors[index];
      locationObject.uploaded = locationObject.originalUploaded.filter(function (element) {
        return element.vendorId === vendor.vendorId;
      });
    };
    const approvedUploadedAll = () => {
      ElMessageBox.confirm("是否要审批通过所有上传照片", "询问", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let activityInstallationApprovedRO = {
          installationId: installationId
        };
        approvedActivityInstallationUploadedAllRequest(activityInstallationApprovedRO);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: "取消审批"
        });
      });
    };
    const approvedUploaded = uploaded => {
      ElMessageBox.confirm("是否要审批通过上传照片", "询问", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        approvedActivityInstallationUploadedRequest(uploaded);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: "取消审批"
        });
      });
    };
    const nullifiedUploaded = uploaded => {
      ElMessageBox.confirm("是否要作废上传照片", "询问", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        nullifiedActivityInstallationUploadedRequest(uploaded);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: "取消审批"
        });
      });
    };
    const approvedActivityInstallationUploadedAllRequest = async activityInstallationApprovedRO => {
      proxy.$api.activityRequest.approvedActivityInstallationUploadedAll(activityInstallationApprovedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202173") {
            if (Array.isArray(storeLocationData.treeData.storeFloors)) {
              for (let storeFloor of storeLocationData.treeData.storeFloors) {
                if (Array.isArray(storeFloor.locations)) {
                  for (let location1 of storeFloor.locations) {
                    if (Array.isArray(location1.locations)) {
                      for (let location2 of location1.locations) {
                        if (Array.isArray(location2.locations)) {
                          for (let location3 of location2.locations) {
                            if (Array.isArray(location3.locations)) {
                              for (let location4 of location3.locations) {
                                if (Array.isArray(location4.uploadedInfo)) {
                                  for (let info of location4.uploadedInfo) {
                                    info.activityInstallationUploadStatusId = 2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            storeLocationData.treeData.storeLocationStatusId = 2;
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "错误",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const approvedActivityInstallationUploadedRequest = async uploaded => {
      let activityInstallationUploadedApprovedRO = {
        activityInstallationToUploadId: uploaded.activityInstallationToUploadId
      };
      proxy.$api.activityRequest.approvedActivityInstallationUploaded(activityInstallationUploadedApprovedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202173") {
            uploaded.activityInstallationUploadStatusId = 2;
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "错误",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const nullifiedActivityInstallationUploadedRequest = async uploaded => {
      let activityInstallationUploadedNullifieRO = {
        activityInstallationToUploadId: uploaded.activityInstallationToUploadId
      };
      proxy.$api.activityRequest.nullifiedActivityInstallationUploaded(activityInstallationUploadedNullifieRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202184") {
            uploaded.activityInstallationUploadStatusId = 3;
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "错误",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const activeTabsKeyChange = activityKey => {};
    const onImageryTabChangeModel = () => {
      if (imageryTabModel.value === 1) {
        imageryTabModel.value = 2;
      } else {
        imageryTabModel.value = 1;
      }
      window.localStorage.setItem("imagery_tab_model", JSON.stringify({
        value: imageryTabModel.value
      }));
    };
    const uploadActivityPhotoData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    const uploadActivityPhoto = ref(null);
    const handleActivityPhotoBeforeUpload = async (file, storeLocationId) => {
      uploadActivityPhotoData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadActivityPhotoData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadActivityPhotoData.signatureData.dir + fullName;
      const uploadData = {
        name: file.name,
        key: keyValue,
        policy: uploadActivityPhotoData.signatureData.policy,
        OSSAccessKeyId: uploadActivityPhotoData.signatureData.accessId,
        signature: uploadActivityPhotoData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid,
        param: {
          storeLocationId: storeLocationId
        }
      };
      uploadActivityPhotoData.data = uploadData;
      file.uploadData = uploadData;
    };
    const handleActivityPhotoExceed = files => {
      // uploadActivityPhoto.value.clearFiles();
      // const file = files[0];
      // file.uid = genFileId();
      // uploadActivityPhoto.value.handleStart(file);
      // uploadActivityPhoto.value.submit();
    };
    const handleActivityPhotoOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let uploadData = file.raw.uploadData;
        let activityInstallationPhotoUploadRO = {
          installationId: installationId,
          storeLocationId: uploadData.param.storeLocationId,
          uploadedRO: {
            fileName: uploadData.name,
            uploadedName: uploadData.key
          }
        };
        uploadActivityInstallationPhotoRequest(activityInstallationPhotoUploadRO);
      }
    };
    const uploadActivityInstallationPhotoRequest = async activityInstallationPhotoUploadRO => {
      proxy.$api.repairRequest.uploadActivityInstallationPhoto(activityInstallationPhotoUploadRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202266") {
            let uploaded = res.result.data;
            storeLocationData.locationsByStoreLocationId[uploaded.storeLocationId].uploaded.unshift(uploaded);
            if (Array.isArray(storeLocationData.treeData.storeFloors)) {
              for (let storeFloor of storeLocationData.treeData.storeFloors) {
                if (Array.isArray(storeFloor.locations)) {
                  for (let location1 of storeFloor.locations) {
                    if (Array.isArray(location1.locations)) {
                      for (let location2 of location1.locations) {
                        if (Array.isArray(location2.locations)) {
                          for (let location3 of location2.locations) {
                            if (Array.isArray(location3.locations)) {
                              for (let location4 of location3.locations) {
                                if (location4.storeLocationId == uploaded.storeLocationId) {
                                  if (!Array.isArray(location4.uploadedInfo)) {
                                    location4.uploadedInfo = [];
                                  }
                                  location4.uploadedInfo.unshift(uploaded);
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const uploadFloorMapData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const uploadFloorMap = ref(null);
    const handleFloorMapBeforeUpload = async file => {
      uploadFloorMapData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadFloorMapData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadFloorMapData.signatureData.dir + fullName;
      const uploadData = {
        name: file.name,
        key: keyValue,
        policy: uploadFloorMapData.signatureData.policy,
        OSSAccessKeyId: uploadFloorMapData.signatureData.accessId,
        signature: uploadFloorMapData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadFloorMapData.data = uploadData;
      file.uploadData = uploadData;
    };
    const handleFloorMapBeforeExceed = files => {};
    const handleFloorMapBeforeOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let uploadData = file.raw.uploadData;
        let floorMapUploadedRO = {
          storeCode: code,
          storeFloor: controlData.currentFloor.storeFloor,
          uploadedRO: {
            fileName: uploadData.name,
            uploadedName: uploadData.key
          }
        };
        uploadFloorMapRequest(floorMapUploadedRO);
      }
    };
    const uploadFloorMapRequest = async floorMapUploadedRO => {
      proxy.$api.storeRequest.uploadFloorMap(floorMapUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202122") {
            let uploaded = res.result.data;
            controlData.currentFloor.storeFloorMap = uploaded.storeFloorMap;
          } else {
            ElNotification({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const removeFloorMapRequest = async floorMapRemoveRO => {
      proxy.$api.storeRequest.removeFloorMap(floorMapRemoveRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202129") {
            let uploaded = res.result.data;
            controlData.currentFloor.storeFloorMap = uploaded.storeFloorMap;
          } else {
            ElNotification({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const floorMapRef = ref(null);
    const selectId = ref(null);
    const handleFloorPointSelected = id => {
      let point = controlData.currentFloor.storeFloorPoints.find(item => item.storeFloorPointId === id);
      let location = null;
      if (point.locationSummary === null) {
        location = storeLocationData.listData.find(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location);
      } else {
        location = storeLocationData.listData.find(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location && item.locationSummary === point.locationSummary);
      }
      if (location) {
        let findIndex = controlData.tab.tabData[0].findIndex(item => item.locationName === location.floor);
        controlData.tab.tabIndex[0] = findIndex;
        controlData.tab.tabData[1] = controlData.tab.tabData[0][findIndex].locations;
        findIndex = controlData.tab.tabData[1].findIndex(item => item.locationName === location.category);
        controlData.tab.tabIndex[1] = findIndex;
        controlData.tab.tabData[2] = controlData.tab.tabData[1][findIndex].locations;
        findIndex = controlData.tab.tabData[2].findIndex(item => item.locationName === location.region);
        controlData.tab.tabIndex[2] = findIndex;
        controlData.tab.tabData[3] = controlData.tab.tabData[2][findIndex].locations;
        findIndex = controlData.tab.tabData[3].findIndex(item => item.locationName === location.location);
        controlData.tab.tabIndex[3] = findIndex;
        controlData.tab.tabData[4] = controlData.tab.tabData[3][findIndex].locations;
        findIndex = controlData.tab.tabData[4].findIndex(item => item.locationName === location.locationSummary);
        controlData.tab.tabIndex[4] = findIndex;
        onChangeTabData(controlData.tab.tabData[4], 5);
      }
      console.log("Selected point ID:", id);
    };
    const selectPoint = id => {
      selectId.value = id;
      // if (floorMapRef.value) {
      //   floorMapRef.value.selectPointById(id);
      // }
    };

    const clearPoint = () => {
      showConfirmModal({
        title: "提示",
        content: "确认删除当前点位？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          dialogFloorMapRef.value.clearSelectPoint();
          dialogControlData.x = null;
          dialogControlData.y = null;
        }
      });
    };
    const onFloorMapOpen = async isLocationSummary => {
      if (isLocationSummary === true || pointLocationSummaryIndex.value === 4) {
        currentIsLocationSummary.value = true;
      } else {
        currentIsLocationSummary.value = null;
        if (locationPointHaveEdit() === false) {
          return;
        }
      }
      let location = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      controlData.locationLabel = location.locationLabel;
      floorMapOpen.value = true;
      dialogControlData.points = controlData.currentFloor.storeFloorPoints.map(floor => ({
        id: floor.storeFloorPointId,
        x: floor.pointX,
        y: floor.pointY
      }));
      await nextTick();
      const point = controlData.currentFloor.storeFloorPoints.find(p => p.storeFloorPointId === selectId.value);
      if (point) {
        dialogControlData.x = point.pointX;
        dialogControlData.y = point.pointY;
        dialogFloorMapRef.value.enterEditMode(point.storeFloorPointId);
      } else {
        dialogControlData.x = null;
        dialogControlData.y = null;
        dialogFloorMapRef.value.enterEditMode(null);
      }
    };
    const onFloorMapRemove = async () => {
      showConfirmModal({
        title: "提示",
        content: "确认移除当前楼层图？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          let floorMapRemoveRO = {
            storeCode: code,
            storeFloor: controlData.currentFloor.storeFloor
          };
          removeFloorMapRequest(floorMapRemoveRO);
        }
      });
    };
    const dialogFloorMapRef = ref(null);
    const floorMapOpen = ref(false);
    const dialogControlData = reactive({
      points: [],
      x: null,
      y: null
    });
    const handleDialogFloorPointSelected = id => {
      console.log("Selected point ID:", id);
    };
    const handleDialogFloorPointChanged = (x, y) => {
      dialogControlData.x = x;
      dialogControlData.y = y;
    };
    const onSavePoint = () => {
      let point = dialogFloorMapRef.value.getSelectPoint();
      let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      if (point.id == -1 && point.x == -30) {
        floorMapOpen.value = false;
      } else if (point.id != -1 && point.x == -30) {
        let deleteFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.floor,
          category: findLocation.category,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: currentIsLocationSummary.value === true ? findLocation.locationSummary : null,
          storeLocationId: controlData.locationInfo.storeLocationId
        };
        deleteFloorPointRequest(deleteFloorPointRO, point.id);
      } else {
        let updateFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.floor,
          category: findLocation.category,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: currentIsLocationSummary.value === true ? findLocation.locationSummary : null,
          pointX: point.x,
          pointY: point.y,
          storeLocationId: controlData.locationInfo.storeLocationId
        };
        updateFloorPointRequest(updateFloorPointRO, point.id);
      }
      console.log("point:", point);
    };
    const updateFloorPointRequest = async (updateFloorPointRO, id) => {
      proxy.$api.storeRequest.updateFloorPoint(updateFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202123") {
            let point = res.result.data;
            if (point.locationSummary === null) {
              pointLocationSummaryIndex.value = 3;
            } else if (point.locationSummary !== null) {
              pointLocationSummaryIndex.value = 4;
            }
            if (id == -1) {
              controlData.currentFloor.storeFloorPoints.push(point);
              selectPoint(point.storeFloorPointId);
            } else {
              controlData.currentFloor.storeFloorPoints = controlData.currentFloor.storeFloorPoints.map(item => {
                if (item.storeFloor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location && item.locationSummary === point.locationSummary) {
                  Object.assign(item, point); // 直接更新对象的属性
                }

                return item;
              });
            }
            floorMapOpen.value = false;
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "错误",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const deleteFloorPointRequest = async (deleteFloorPointRO, id) => {
      proxy.$api.storeRequest.deleteFloorPoint(deleteFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202125") {
            controlData.currentFloor.storeFloorPoints = controlData.currentFloor.storeFloorPoints.filter(item => {
              return item.storeFloorPointId !== id;
            });
            pointLocationSummaryIndex.value = null;
            floorMapOpen.value = false;
            ElNotification({
              title: "成功",
              message: res.result.promptMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "错误",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const onActivityRepair = () => {
      uploadTableData.fileList.length = 0;
      uploadTableData.uploadedList.length = 0;
      repairEditFormData.repairUrgent = 1;
      repairEditFormData.storeLocationId = null;
      repairEditFormData.reporterName = null;
      repairEditFormData.reporterMobile = null;
      repairEditFormData.reporterDescription = null;
      let location = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      let activityRepairWxCodeRO = {
        locationName: location.locationLabel,
        storeLocationId: location.storeLocationId,
        storeName: storeLocationData.treeData.storeName,
        storeCode: code
      };
      activityRepairWxCodeRequest(activityRepairWxCodeRO);
    };
    const activityRepairWxCodeRequest = activityRepairWxCodeRO => {
      proxy.$api.wxRequest.getActivityRepairWxCode(activityRepairWxCodeRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "200000") {
            wxCodeImage.value = res.result.data;
            // QRcodeVisible.value = true;
            repairOpenVisible.value = true;
          } else {
            ElNotification({
              title: "失败",
              message: res.result.promptMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    //二维码复制
    const copyQrcode = () => {
      html2canvas(QRcodeBox.value, {
        useCORS: true,
        // 【重要】开启跨域配置
        allowTaint: true // 允许跨域图片
      }).then(canvas => {
        canvas.toBlob(blob => {
          const data = [new ClipboardItem({
            [blob.type]: blob
          })];
          navigator.clipboard.write(data).then(() => {
            console.log("成功");
            ElNotification({
              title: "成功",
              message: "已复制到剪切板",
              type: "success",
              duration: 3000
            });
          }, () => {
            console.log("失败");
            ElNotification({
              title: "失败",
              message: "复制失败，此浏览器不支持",
              type: "error",
              duration: 3000
            });
          });
        }, "image/png");
      });
    };
    const currentIsLocationSummary = ref(null);
    const onAddPoint = (event, index) => {
      event.stopPropagation();
      changeTab(index, 4);
      onFloorMapOpen(true);
    };
    const locationSummaryHaveAdd = location => {
      let storeLocation = storeLocationData.locationsByStoreLocationId[location.storeLocationId];
      let findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === storeLocation.floor && item.category === storeLocation.category && item.region === storeLocation.region && item.location === storeLocation.location && item.locationSummary === null);
      if (findIndex !== -1) {
        return false;
      } else {
        findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === storeLocation.floor && item.category === storeLocation.category && item.region === storeLocation.region && item.location === storeLocation.location && item.locationSummary === storeLocation.locationSummary);
        if (findIndex != -1) {
          return false;
        }
      }
      return true;
    };
    const locationPointHaveEdit = () => {
      debugger;
      const point = controlData.currentFloor.storeFloorPoints.find(p => p.storeFloorPointId === selectId.value);
      if (point) {
        return true;
      } else {
        let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
        let floors = controlData.currentFloor.storeFloorPoints.filter(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location);
        if (floors.length === 0) {
          return true;
        }
      }
      return false;
    };
    const uploadTable = ref(null);
    const uploadTableData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: [],
      uploadedList: [],
      repairActivityObj: {}
    });
    const handleRemove = (uploadFile, uploadFiles, index) => {
      console.log(uploadFile, uploadFiles, index);
    };
    const handlePictureCardPreview = uploadFile => {
      console.log("点击了");
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };
    const handleExceed = () => {
      ElNotification({
        title: "失败",
        message: "最多上传3张图片",
        type: "error",
        duration: 6000
      });
    };
    //文件上传成功的钩子
    const handleStoreOnSuccess = async (response, file) => {
      console.log("file" + file);
      if (file.status === "success") {
        let uploadedRO = {
          fileName: uploadTableData.data.name,
          uploadedName: uploadTableData.data.key,
          uid: file.uid
        };
        uploadTableData.uploadedList.push(uploadedRO);
      }
    };

    //上传文件之前的钩子
    const handleStoreBeforeUpload = async file => {
      uploadTableData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadTableData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadTableData.signatureData.dir + fullName;
      uploadTableData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadTableData.signatureData.policy,
        OSSAccessKeyId: uploadTableData.signatureData.accessId,
        signature: uploadTableData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadTableData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const onRepairSave = () => {
      repairEditForm.value.validate().then(async () => {
        if (uploadTableData.uploadedList.length === 0) {
          ElNotification({
            title: "失败",
            message: "请上传报修改故障照片",
            type: "error",
            duration: 3000
          });
          return;
        }
        let formData = JSON.parse(JSON.stringify(repairEditFormData.value));
        let repairAddRO = {
          repairUrgent: formData.repairUrgent,
          reporterDescription: formData.reporterDescription,
          customStoreLocation: formData.customStoreLocation,
          reporterName: formData.reporterName,
          reporterMobile: formData.reporterMobile,
          storeCode: formData.storeCode,
          storeLocationId: formData.storeLocationId,
          uploaded: uploadTableData.uploadedList
        };
        proxy.$api.repairRequest.addRepair(repairAddRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202280") {
              repairEditForm.value.resetFields();
              uploadTable.value.clearFiles();
              ElNotification({
                title: "成功",
                message: res.result.promptMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "失败",
                message: res.result.promptMsg,
                type: "error",
                duration: 6000
              });
            }
            repairOpenVisible.value = false;
          } else {
            ElNotification({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 6000
            });
            repairOpenVisible.value = false;
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "错误",
              message: error,
              type: "error",
              duration: 3000
            });
          }
          repairOpenVisible.value = false;
        });
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onRepairCancel = () => {
      repairEditForm.value.resetFields();
      uploadTable.value.clearFiles();
      repairOpenVisible.value = false;
    };
    const customStoreLocationRules = computed(() => {
      if (repairEditFormData.value.storeLocationId === 0) {
        return [{
          required: true,
          message: "请输入自定义点位"
        }];
      }
      return [];
    });
    const repairStoreLocationChange = value => {
      if (value === 0) {} else {
        repairEditFormData.value.customStoreLocation = null;
        repairEditForm.value.clearValidate("customStoreLocation");
      }
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tree_select = _resolveComponent("a-tree-select");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_form = _resolveComponent("a-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, _toDisplayString(storeLocationData.treeData.storeName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, "店铺编码: " + _toDisplayString(storeLocationData.treeData.storeCode), 1), _createElementVNode("div", null, "店铺类型: " + _toDisplayString(storeLocationData.treeData.storeTypeNameZh), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, "省份:" + _toDisplayString(storeLocationData.treeData.province), 1), _createElementVNode("div", null, "城市:" + _toDisplayString(storeLocationData.treeData.city), 1), _createElementVNode("div", null, "地址:" + _toDisplayString(storeLocationData.treeData.storeAddress), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, "联系人:" + _toDisplayString(storeLocationData.treeData.contactName), 1), _createElementVNode("div", null, "联系方式:" + _toDisplayString(storeLocationData.treeData.contactMobile), 1), _createElementVNode("div", null, "邮箱:" + _toDisplayString(storeLocationData.treeData.contactEmail), 1)])]), _createElementVNode("div", _hoisted_8, [_unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && storeLocationData.treeData.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => approvedUploadedAll()),
        class: "sts-button default",
        style: {
          "width": "83px",
          "height": "25px",
          "padding": "0",
          "margin-left": "20px",
          "position": "absolute",
          "top": "10px",
          "right": "5px",
          "z-index": "1"
        }
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorPrimary: '#777777',
              colorText: '#C4C4C4',
              motionDurationMid: 0,
              motionDurationSlow: 0
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          class: "sts-tabs default",
          activeKey: dataTabsKey.value,
          "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => dataTabsKey.value = $event),
          type: "card",
          animated: false,
          onChange: activeTabsKeyChange
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "1"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_button, {
              onClick: onImageryTabChangeModel,
              shape: "circle",
              style: {
                "width": "16px",
                "height": "16px",
                "padding": "0px",
                "min-width": "unset",
                "border": "0",
                "margin-left": "10px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "list",
                iconColor: '#777777',
                iconSize: "14px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [imageryTabModel.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [controlData.currentUploadedInfo ? (_openBlock(), _createBlock(_component_a_image, {
              key: 0,
              src: controlData.currentUploadedInfo.url,
              fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404Big.jpg",
              style: {
                "width": "352px",
                "height": "264px",
                "min-width": "352px",
                "min-height": "264px"
              }
            }, null, 8, ["src"])) : _createCommentVNode("", true), !controlData.currentUploadedInfo ? (_openBlock(), _createElementBlock("div", _hoisted_15)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_hoisted_17, _hoisted_18, _unref(activityId) && controlData.locationInfo ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.locationInfo.activityVendors, (data, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "display": "flex"
                }
              }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                color: "#ff3f22",
                iconName: "Tips",
                iconSize: "12px"
              })) : _createCommentVNode("", true), index < controlData.locationInfo.activityVendors.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, " / ")) : _createCommentVNode("", true)]);
            }), 128))])) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "orange"
            }, {
              default: _withCtx(() => [_createTextVNode("未审核")]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 2 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "green"
            }, {
              default: _withCtx(() => [_createTextVNode("已审核")]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 3 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "red"
            }, {
              default: _withCtx(() => [_createTextVNode("拒绝")]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' && _unref(permission).havePermission('店铺管理', '活动照片审核') && controlData.locationInfo.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              style: {
                "height": "25px",
                "padding": "0px 15px"
              },
              onClick: _cache[1] || (_cache[1] = $event => approvedUploaded(controlData.currentUploadedInfo)),
              class: "sts-button green"
            }, {
              default: _withCtx(() => [_createTextVNode("审核通过")]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' && _unref(permission).havePermission('店铺管理', '活动照片审核') && controlData.locationInfo.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
              key: 5,
              style: {
                "margin-left": "10px",
                "height": "25px",
                "padding": "0px 15px"
              },
              onClick: _cache[2] || (_cache[2] = $event => nullifiedUploaded(controlData.currentUploadedInfo)),
              class: "sts-button danger"
            }, {
              default: _withCtx(() => [_createTextVNode("拒绝")]),
              _: 1
            })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, " 宽：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.width), 1), _createElementVNode("div", null, " 高：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.height), 1), _createElementVNode("div", null, " 性别：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.gender), 1), _createElementVNode("div", null, " ICE：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.ice), 1), _createElementVNode("div", null, " 材质：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.materialAndCraft), 1), _createElementVNode("div", null, " 数量：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.quantity), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, " 尺寸：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.sizeDescription), 1), _createElementVNode("div", null, " 支持类型：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.supportType), 1), _createElementVNode("div", null, " 位置描述：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.locationDescription), 1)])])]), _createElementVNode("div", _hoisted_24, [controlData.locationInfo ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.locationInfo.uploadedInfo, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center"
                },
                key: index
              }, [_unref(activityId) ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.vendorName), 1)) : _createCommentVNode("", true), _createVNode(_component_a_image, {
                style: {
                  "width": "80px",
                  "height": "80px",
                  "cursor": "pointer"
                },
                onClick: $event => onPreviewChange(item),
                class: _normalizeClass([{
                  active: item === controlData.currentUploadedInfo
                }, "preview-image"]),
                src: item.url,
                preview: false,
                fit: "cover",
                fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404small.jpg"
              }, null, 8, ["onClick", "class", "src"])]);
            }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(MapWithMarkers, {
              ref_key: "floorMapRef",
              ref: floorMapRef,
              imageSrc: controlData.currentFloor ? controlData.currentFloor.storeFloorMap : '',
              selectId: selectId.value,
              initialPoints: initialPoints.value,
              onPointSelected: handleFloorPointSelected
            }, null, 8, ["imageSrc", "selectId", "initialPoints"]), !controlData.currentFloor || !controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 没有楼层平面图 ")) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
              class: "logo-upload-box",
              ref_key: "uploadFloorMap",
              ref: uploadFloorMap,
              accept: "image/png, image/jpeg, image/gif, image/jpg",
              "show-file-list": false,
              action: uploadFloorMapData.signatureData.host,
              "before-upload": file => {
                return handleFloorMapBeforeUpload(file);
              },
              "on-success": handleFloorMapBeforeOnSuccess,
              data: uploadFloorMapData.data,
              "on-exceed": handleFloorMapBeforeExceed,
              "file-list": uploadFloorMapData.fileList
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_svg_icon, {
                iconName: "upload",
                iconColor: '#ffffff',
                iconSize: "16px"
              })])]),
              _: 1
            }, 8, ["action", "before-upload", "data", "file-list"]), controlData.currentFloor && controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: {
                "width": "24px",
                "height": "24px",
                "border-radius": "50%",
                "bottom": "60px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
              },
              class: _normalizeClass({
                edit_enable: locationPointHaveEdit() === true,
                edit_disable: locationPointHaveEdit() === false
              }),
              onClick: onFloorMapOpen
            }, [_createVNode(_component_svg_icon, {
              iconName: "activityEdit",
              iconColor: '#ffffff',
              iconSize: "16px"
            })], 2)) : _createCommentVNode("", true), controlData.currentFloor && controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              style: {
                "width": "24px",
                "height": "24px",
                "background-color": "#fa00a5",
                "border-radius": "50%",
                "bottom": "30px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "cursor": "pointer"
              },
              onClick: onFloorMapRemove
            }, [_createVNode(_component_svg_icon, {
              iconName: "tk_sub",
              iconColor: '#ffffff',
              iconSize: "16px"
            })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[0], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[0] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 0),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_34);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_35, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[1], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[1] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 1),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_36);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_37, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[2], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[2] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 2),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_38);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_39, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[3], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active_flag: controlData.tab.tabIndex[3] === index && pointLocationSummaryIndex.value === 3,
                    active: controlData.tab.tabIndex[3] === index && pointLocationSummaryIndex.value !== 3
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 3),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_40);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_41, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[4], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active_flag: controlData.tab.tabIndex[4] === index && pointLocationSummaryIndex.value === 4,
                    active: controlData.tab.tabIndex[4] === index && pointLocationSummaryIndex.value !== 4
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 4),
                  key: index
                }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(location.locationName), 1), locationSummaryHaveAdd(location) === true ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  style: {
                    "background-color": "rgb(0, 165, 250)",
                    "border-radius": "50%",
                    "margin-left": "3px"
                  },
                  iconName: "add",
                  iconColor: '#ffffff',
                  iconSize: "16px",
                  onClick: $event => onAddPoint($event, index)
                }, null, 8, ["onClick"])) : _createCommentVNode("", true)])], 10, _hoisted_42);
              }), 128))]),
              _: 1
            })])]), _createElementVNode("div", _hoisted_45, [_unref(permission).havePermission('店铺管理', '报修') ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: onActivityRepair,
              class: "sts-button default",
              style: {
                "width": "83px",
                "height": "25px",
                "padding": "0",
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_hoisted_46]),
              _: 1
            })) : _createCommentVNode("", true)])])])])])) : _createCommentVNode("", true), imageryTabModel.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_hoisted_48, _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeLocationData.listData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "display": "flex",
                  "height": "170px",
                  "align-items": "center",
                  "flex-shrink": "0"
                }
              }, [_createElementVNode("div", _hoisted_51, _toDisplayString(item.floor), 1), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", null, _toDisplayString(item.category), 1), _createElementVNode("div", null, _toDisplayString(item.region), 1), _createElementVNode("div", null, _toDisplayString(item.location), 1), _createElementVNode("div", null, _toDisplayString(item.locationSummary), 1)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", null, "宽：" + _toDisplayString(item.width), 1), _createElementVNode("div", null, "高：" + _toDisplayString(item.height), 1), _createElementVNode("div", null, "性别：" + _toDisplayString(item.gender), 1), _createElementVNode("div", null, "ICE：" + _toDisplayString(item.ice), 1), _createElementVNode("div", null, "材质：" + _toDisplayString(item.materialAndCraft), 1)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", null, "数量：" + _toDisplayString(item.quantity), 1), _createElementVNode("div", null, "尺寸：" + _toDisplayString(item.sizeDescription), 1), _createElementVNode("div", null, "支持类型：" + _toDisplayString(item.supportType), 1), _createElementVNode("div", null, "位置描述：" + _toDisplayString(item.locationDescription), 1)])]), _createElementVNode("div", _hoisted_56, _toDisplayString(item.activityName), 1), _createElementVNode("div", _hoisted_57, [_unref(activityId) ? (_openBlock(), _createElementBlock("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.activityVendors, (data, index) => {
                return _openBlock(), _createElementBlock("div", {
                  style: {
                    "display": "flex",
                    "align-items": "center"
                  },
                  class: _normalizeClass([{
                    active: index === item.vendorTabIndex
                  }, "filter-button"]),
                  onClick: $event => {
                    item.vendorTabIndex = index;
                    vendorTabBarChange(item, index);
                  },
                  key: index
                }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  style: {
                    "margin-left": "3px"
                  },
                  color: "#ff3f22",
                  iconName: "Tips",
                  iconSize: "12px"
                })) : _createCommentVNode("", true)], 10, _hoisted_59);
              }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_60, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.uploaded, (x, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "120px",
                    "margin-left": "5px"
                  }
                }, [_createVNode(_component_a_image, {
                  src: x.url,
                  fit: "cover",
                  style: {
                    "width": "120px",
                    "height": "120px"
                  },
                  fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404small.jpg"
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_61, [x.activityInstallationUploadStatusId == 1 && _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: $event => approvedUploaded(x),
                  class: "sts-button default",
                  style: {
                    "width": "60px",
                    "height": "25px",
                    "padding": "0"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_62]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true), x.activityInstallationUploadStatusId == 1 && _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  onClick: $event => nullifiedUploaded(x),
                  class: "sts-button default",
                  style: {
                    "width": "60px",
                    "height": "25px",
                    "padding": "0",
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_63]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)])]);
              }), 128)), _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(_component_el_upload, {
                class: "logo-upload-box",
                ref_for: true,
                ref_key: "uploadActivityPhoto",
                ref: uploadActivityPhoto,
                accept: "image/png, image/jpeg, image/gif, image/jpg",
                "show-file-list": false,
                action: uploadActivityPhotoData.signatureData.host,
                "before-upload": file => {
                  return handleActivityPhotoBeforeUpload(file, item.storeLocationId);
                },
                "on-success": handleActivityPhotoOnSuccess,
                data: uploadActivityPhotoData.data,
                "on-exceed": handleActivityPhotoExceed,
                "file-list": uploadActivityPhotoData.fileList,
                multiple: ""
              }, {
                default: _withCtx(() => [uploadActivityPhotoData.file.url === null ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "sts-button default",
                  style: {
                    "width": "83px",
                    "height": "25px",
                    "padding": "0",
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => [_hoisted_65]),
                  _: 1
                })) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["action", "before-upload", "data", "file-list"])])) : _createCommentVNode("", true)])])]);
            }), 128))])])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            key: "2"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_hoisted_67, _createVNode(_component_a_button, {
              shape: "circle",
              style: {
                "width": "16px",
                "height": "16px",
                "padding": "0px",
                "min-width": "unset",
                "border": "0",
                "margin-left": "10px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "list",
                iconColor: '#777777',
                iconSize: "14px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_hoisted_68]),
            _: 1
          })]),
          _: 1
        }, 8, ["activeKey"])]),
        _: 1
      })])])]), _createVNode(_component_a_modal, {
        open: floorMapOpen.value,
        "onUpdate:open": _cache[7] || (_cache[7] = $event => floorMapOpen.value = $event),
        closable: false,
        width: "764px",
        zIndex: 1001,
        centered: true,
        maskClosable: false
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString(controlData.locationLabel) + " 一楼女子生活区服装墙多层板画面 ", 1), _hoisted_71, _createVNode(_component_a_button, {
          onClick: clearPoint,
          style: {
            "border-radius": "4px",
            "height": "25px",
            "padding": "0px 15px",
            "margin-left": "10px"
          },
          class: "sts-button danger"
        }, {
          default: _withCtx(() => [_createTextVNode("清除")]),
          _: 1
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createVNode(_component_a_space, null, {
          default: _withCtx(() => [_hoisted_74, _createVNode(_component_a_input, {
            value: dialogControlData.x,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => dialogControlData.x = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"]), _hoisted_75, _createVNode(_component_a_input, {
            value: dialogControlData.y,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => dialogControlData.y = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _hoisted_76, _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: _cache[6] || (_cache[6] = $event => floorMapOpen.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onSavePoint
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_72, [floorMapOpen.value ? (_openBlock(), _createBlock(MapWithMarkers, {
          key: 0,
          ref_key: "dialogFloorMapRef",
          ref: dialogFloorMapRef,
          imageSrc: controlData.currentFloor.storeFloorMap,
          initialPoints: dialogControlData.points,
          onPointSelected: handleDialogFloorPointSelected,
          onPointChanged: handleDialogFloorPointChanged
        }, null, 8, ["imageSrc", "initialPoints"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: repairOpenVisible.value,
        "onUpdate:open": _cache[15] || (_cache[15] = $event => repairOpenVisible.value = $event),
        closable: false,
        zIndex: 1001,
        width: 700,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_hoisted_78, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onRepairCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onRepairSave
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_createElementVNode("img", {
          style: {
            "width": "150px",
            "height": "150px"
          },
          src: wxCodeImage.value
        }, null, 8, _hoisted_80)]), _createVNode(_component_a_form, {
          model: repairEditFormData.value,
          ref_key: "repairEditForm",
          ref: repairEditForm,
          class: "sts-form",
          "label-col": {
            span: 8
          },
          "label-align": "left",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, null, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "报修门店:",
                name: "storeName",
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.storeName,
                  "onUpdate:value": _cache[8] || (_cache[8] = $event => repairEditFormData.value.storeName = $event)
                }, null, 8, ["value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "报修点位:",
                name: "storeLocationId",
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_tree_select, {
                  value: repairEditFormData.value.storeLocationId,
                  "onUpdate:value": _cache[9] || (_cache[9] = $event => repairEditFormData.value.storeLocationId = $event),
                  treeData: storeLocationData.treeOptionData,
                  treeDefaultExpandAll: true,
                  defaultExpandAll: "",
                  fieldNames: storeLocationTreeProps,
                  onChange: repairStoreLocationChange,
                  treeNodeLabelProp: 'fullPath',
                  style: {
                    "width": "300px"
                  }
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["value", "treeData"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "自定义点位:",
                name: "customStoreLocation",
                rules: customStoreLocationRules.value,
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  disabled: repairEditFormData.value.storeLocationId != 0,
                  value: repairEditFormData.value.customStoreLocation,
                  "onUpdate:value": _cache[10] || (_cache[10] = $event => repairEditFormData.value.customStoreLocation = $event)
                }, null, 8, ["disabled", "value"])]),
                _: 1
              }, 8, ["rules"]), _createVNode(_component_a_form_item, {
                label: "报修人:",
                name: "reporterName",
                rules: [{
                  required: true,
                  message: '请输入报修人'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.reporterName,
                  "onUpdate:value": _cache[11] || (_cache[11] = $event => repairEditFormData.value.reporterName = $event)
                }, null, 8, ["value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "联系方式:",
                name: "reporterMobile",
                rules: [{
                  required: true,
                  message: '请输入联系方式'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.reporterMobile,
                  "onUpdate:value": _cache[12] || (_cache[12] = $event => repairEditFormData.value.reporterMobile = $event)
                }, null, 8, ["value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "是否紧急:",
                name: "repairUrgent",
                rules: [{
                  required: true,
                  message: '请选择是否紧急'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  "show-search": "",
                  dropdownMatchSelectWidth: false,
                  options: [{
                    label: '是',
                    value: 1
                  }, {
                    label: '否',
                    value: 0
                  }],
                  style: {
                    "width": "110px"
                  },
                  popupClassName: "sts-select-dropdown",
                  value: repairEditFormData.value.repairUrgent,
                  "onUpdate:value": _cache[13] || (_cache[13] = $event => repairEditFormData.value.repairUrgent = $event)
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "需求描述:",
                name: "reporterDescription",
                rules: [{
                  required: true,
                  message: '请输入需求描述'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_textarea, {
                  "auto-size": {
                    minRows: 2
                  },
                  value: repairEditFormData.value.reporterDescription,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => repairEditFormData.value.reporterDescription = $event)
                }, null, 8, ["value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "故障照片:",
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  class: "repair_upload",
                  "file-list": uploadTableData.fileList,
                  "list-type": "picture-card",
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove,
                  limit: 3,
                  ref_key: "uploadTable",
                  ref: uploadTable,
                  action: uploadTableData.signatureData.host,
                  "before-upload": handleStoreBeforeUpload,
                  "on-exceed": handleExceed,
                  "before-remove": _ctx.handleBeforeRemove,
                  "on-success": handleStoreOnSuccess,
                  data: uploadTableData.data,
                  accept: "image/*"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Plus))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["file-list", "action", "before-remove", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_el_dialog, {
        modelValue: QRcodeVisible.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => QRcodeVisible.value = $event),
        width: "30%",
        "align-center": "",
        modal: false,
        "append-to-body": "",
        style: {
          "min-width": "300px",
          "max-width": "300px",
          "min-height": "300px"
        },
        "show-close": false
      }, {
        header: _withCtx(() => [_hoisted_86, _createElementVNode("div", _hoisted_87, [_createVNode(_component_svg_icon, {
          iconName: "copy",
          iconSize: "20px",
          onClick: _cache[16] || (_cache[16] = $event => copyQrcode())
        })])]),
        default: _withCtx(() => [_createElementVNode("div", {
          style: {
            "display": "flex",
            "flex-direction": "column",
            "align-items": "center"
          },
          id: "QRcodeBox",
          ref_key: "QRcodeBox",
          ref: QRcodeBox
        }, [_hoisted_82, _createElementVNode("div", _hoisted_83, [_createElementVNode("img", {
          style: {
            "width": "150px",
            "height": "150px"
          },
          src: wxCodeImage.value
        }, null, 8, _hoisted_84)]), _hoisted_85], 512)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};